import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "childElement", "childOnActive", "isActive", "pulser", "pulserRef", "readyToStart", "scrollTo", "scrollToTarget", "target", "targetRef", "open", "onOpenStart", "onCloseStart"];
let _ = t => t,
  _t;
import { useEffect, useRef, cloneElement } from 'react';
import { createGlobalStyle } from 'styled-components';
import UITourPulser from '../../pulser/UITourPulser';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UITourPulserGlobalStyle = createGlobalStyle(_t || (_t = _`
  html,
  body {
    overflow: hidden;
  }
`));
const TourStepChildren = _ref => {
  let {
      children,
      childElement,
      childOnActive,
      isActive,
      pulser,
      pulserRef,
      readyToStart,
      scrollTo,
      scrollToTarget,
      target,
      targetRef,
      open,
      onOpenStart,
      onCloseStart
    } = _ref,
    receivedProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const showScrollToTarget = scrollTo && !target && !scrollToTarget;
  const showChildOnActive = readyToStart && childOnActive;
  const showPulser = readyToStart && pulser;
  const previousOpen = useRef(open);

  // Using isActive instead of readyToStart here because global style needs to be appended before `beforeStart` hook and `scrollToTarget`
  const shouldPreventOverflow = isActive && typeof pulser === 'object' && pulser.preventOverflow === true;
  useEffect(() => {
    if (open !== previousOpen.current) {
      if (open) {
        onOpenStart === null || onOpenStart === void 0 || onOpenStart();
      } else {
        onCloseStart === null || onCloseStart === void 0 || onCloseStart();
      }
      previousOpen.current = open;
    }
  }, [open, onCloseStart, onOpenStart]);

  // solves an edge case where children is an array of elements (integrations-lib + IntegrationsUISpaceSword)
  const [firstChild, ...restChildren] = children && Array.isArray(children) ? children : [children];
  const clonedChild = firstChild ? /*#__PURE__*/cloneElement(firstChild, receivedProps) : null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [clonedChild, restChildren, showScrollToTarget && /*#__PURE__*/_jsx("span", {
      ref: targetRef
    }), showChildOnActive && childOnActive, showPulser && /*#__PURE__*/_jsx(UITourPulser, Object.assign({
      ref: pulserRef,
      target: target || childElement
    }, typeof pulser === 'object' && pulser)), shouldPreventOverflow && /*#__PURE__*/_jsx(UITourPulserGlobalStyle, {})]
  });
};
export default TourStepChildren;